<template>
    <v-form class="px-2"
            v-model="valid"
            ref="form"
            lazy-validation
            @submit.prevent="">
        <v-row class="pt-2"   >
            <v-col cols="12" class="text-center" style="color: #172B4D">
                {{ $t('login.recoverPassword') }}
            </v-col>

            <v-col cols="12" class="pb-2" v-if="validateEmailOrPhone.value === 'phone'">
                <country-picker solo v-model="country"/>
            </v-col>

            <v-col class="pb-2" cols="12">
                <v-text-field :placeholder="$t('login.emailOrPhone')"
                              hide-details
                              v-model="emailOrPhone"
                              solo
                              @keyup.enter="submit()">
                    <v-row class="fill-height"  align="center" slot="prepend-inner">
                        <v-icon class="px-4"
                                color="#172B4D">
                            {{ validateEmailOrPhone.icon }}
                        </v-icon>
                        <template v-if="validateEmailOrPhone.value === 'phone'">
                            <div class="pr-3 grey--text">+{{country.number || '1'}}</div>
                        </template>
                    </v-row>
                </v-text-field>
            </v-col>

            <v-col class="pt-3 text-center" cols="12" >
                <v-btn style="font-size: 16px"
                       class="mr-4"
                       color="#11CDEF"
                       dark
                       @click="submit"
                       :loading="loading">
                    {{ $t('login.recover') }}
                </v-btn>

                <v-btn style="font-size: 13px"
                       @click="$emit('changeSection', 'keybeLogin')">
                    {{ $t('login.goBack') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import authService from '@/services/authService'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import validations from '@/libs/validations'
import { EventBus } from '../../eventBus'
import CountryPicker from '@/components/ui/CountryPicker.vue'
export default {
  components: {
    CountryPicker
  },
  computed: {
    validateEmailOrPhone () {
      const patternOnlyNumbers = /^[0-9]+$/
      if (!this.emailOrPhone) return { icon: 'feather-user', value: 'none' }
      if (patternOnlyNumbers.test(this.emailOrPhone)) return { icon: 'fas fa-mobile-alt', value: 'phone' }
      if (!patternOnlyNumbers.test(this.emailOrPhone)) return { icon: 'far fa-envelope', value: 'email' }
      else return ''
    }
  },
  data () {
    return {
      country: {},
      valid: false,
      loading: false,
      emailOrPhone: '',
      rules: rules
    }
  },
  methods: {
    async submit () {
      const inputType = this.validateEmailOrPhone.value
      if (!inputType || inputType === 'none' || !this.emailOrPhone.trim()) {
        notifications.error(this.$t('rules.emailOrPhoneAreRequired'))
        return
      }
      if (!validations.resetPassword({
        type: inputType,
        emailOrPhone: this.emailOrPhone
      })) return
      try {
        this.loading = true
        if (inputType === 'email') {
          await authService.resetPasswordEmail(this.emailOrPhone)
        } else if (inputType === 'phone') {
          await authService.resetPasswordPhone(this.emailOrPhone, this.country.code)
        }
        EventBus.$emit('SET_CONTACT_WAY', inputType)
        this.$emit('changeSection', 'keybeNewPassword')
        return true
      } catch (e) {
        this.loading = false
        console.error(e)
        throw e
      }
    }
  }
}
</script>

<style scoped>
    ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
        box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
        text-decoration: none!important;
    }
    ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot input {
        border-bottom: none!important;
    }
</style>
